import { z } from "zod";

import { publicLocaleSchema } from "./locales.js";

export const changeTypeSchema = z.enum([
  "cases_updated",
  "region_added",
  "timeline_event",
  "advisory_added",
  "news_breaking",
]);

export const changeSeveritySchema = z.enum(["info", "warning", "emergency"]);

export const changesSinceTimestampInputSchema = z.object({
  slug: z.string().min(1),
  since: z.string().datetime(),
  locale: publicLocaleSchema.default("en"),
  limit: z.number().int().min(1).max(50).default(20),
});

export const changeSummarySchema = z.object({
  id: z.string().uuid(),
  changeType: changeTypeSchema,
  summary: z.string(),
  severity: changeSeveritySchema,
  sourceUrl: z.string().nullable(),
  occurredAt: z.string(),
});

export const changesSinceTimestampOutputSchema = z.object({
  count: z.number().int(),
  items: z.array(changeSummarySchema),
});

export type ChangeType = z.infer<typeof changeTypeSchema>;
export type ChangeSeverity = z.infer<typeof changeSeveritySchema>;
export type ChangeSummary = z.infer<typeof changeSummarySchema>;
export type ChangesSinceTimestampInput = z.infer<typeof changesSinceTimestampInputSchema>;
export type ChangesSinceTimestampOutput = z.infer<typeof changesSinceTimestampOutputSchema>;
